module.exports = __webpack_public_path__ + "static/media/puzzle.bedb71e4.png";